// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as AppStorage from "../../utils/AppStorage.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as ChangePassword from "./ChangePassword.bs.jsx";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as InputThrustDevice from "../../components/InputThrustDevice/InputThrustDevice.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  return state.name;
}

function set(_state, field, value) {
  return {
    name: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function EditUser(props) {
  let onChangePassword = props.onChangePassword;
  let onSubmit = props.onSubmit;
  React.useEffect(() => {
    let initialThrustDevide = AppStorage.getThrustDevice() !== undefined;
    return () => {
      let unmountThrustDevice = AppStorage.getThrustDevice() !== undefined;
      if (initialThrustDevide !== unmountThrustDevice) {
        window.location.reload();
        return;
      }
    };
  }, []);
  let form = Form.use({
    name: props.initialName
  }, Validators$1.schema([Validators$1.required("Name")]), param => {
    let raiseSubmitFailed = param.raiseSubmitFailed;
    Stdlib_Promise.$$catch(onSubmit(param.state.values), error => {
      let errorMessage;
      if (error.RE_EXN_ID === "JsExn") {
        let msg = Stdlib_JsExn.message(error._1);
        errorMessage = msg !== undefined ? `Chyba: ` + msg : "Neznámá chyba";
      } else {
        errorMessage = "Neznámá chyba";
      }
      raiseSubmitFailed(errorMessage);
      return Promise.resolve();
    });
  }, undefined, undefined, "OnDemand", undefined);
  let match = React.useState(() => "Hidden");
  let setDialogState = match[1];
  let hideDialog = param => setDialogState(param => "Hidden");
  let tmp;
  tmp = match[0] === "Hidden" ? null : <ChangePassword.make
      onDismiss={hideDialog}
      onSubmit={values => onChangePassword(values).then(() => {
        setDialogState(param => "Hidden");
        return Promise.resolve();
      })}
    />;
  return <>
    <DialogForm.make
      formId={"edit_user"}
      heading={"Úprava uživatele"}
      onDismiss={props.onDismiss}
      visible={true}
    >
      <Form.Provider.make
        value={form}
      >
        <form
          id={"edit_user"}
          onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
        >
          <fieldset
            className={`reset ` + Styles.fieldset.grid}
          >
            <Form.Field.make
              field={"Name"}
              render={field => <InputWrapper.make
                inputError={field.error}
                inputName={"name"}
                inputSlot={<input
                  type={"text"}
                  value={field.value}
                  onChange={ReForm__Helpers.handleChange(field.handleChange)}
                />}
                labelSlot={"Přezdívka"}
              />}
            />
            <InputWrapper.make
              inputName={"email"}
              inputSlot={<input
                disabled={true}
                type={"text"}
                value={props.connectedEmail}
              />}
              labelSlot={"E-mail"}
            />
            <button
              className={Styles.button.base + ` ` + Styles.fieldset.gridSpan}
              type={"button"}
              onClick={param => setDialogState(param => "ChangePassword")}
            >
              {"Změnit heslo"}
            </button>
            <InputThrustDevice.make />
          </fieldset>
        </form>
      </Form.Provider.make>
    </DialogForm.make>
    {tmp}
  </>;
}

let make = EditUser;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
